import * as editScoringActions from '../actions/editScoring';

const defaultState = {
    isLoading: true,
    isRemovingWarningFlag: false,
    form: {
        initialValues: {},
        initialStatus: {
            errors: {},
        },
    },
    calculatedScore: null,
    nationalAverages: [],
    toggledClass: null,
    likelihoodScalePoints: [],
};

export default function (state = defaultState, action) {
    switch (action.type) {
        case editScoringActions.TOGGLE_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case editScoringActions.INITIAL_FORM_VALUES_REFRESHED:
            return {
                ...state,
                form: {
                    ...state.form,
                    initialValues: action.initialValues,
                },
            };
        case editScoringActions.CALCULATED_SCORE_REFRESHED:
            return {
                ...state,
                calculatedScore: action.calculatedScore,
            };
        case editScoringActions.NATIONAL_AVERAGES_REFRESHED:
            return {
                ...state,
                nationalAverages: action.nationalAverages,
            };
        case editScoringActions.LIKELIHOOD_SCALE_POINTS_REFRESHED:
            return {
                ...state,
                likelihoodScalePoints: action.likelihoodScalePoints,
            };
        case editScoringActions.HARM_CLASS_TOGGLED:
            return {
                ...state,
                toggledClass: action.toggledClass,
            };
        case editScoringActions.SET_IS_REMOVING_WARNING_FLAG:
            return {
                ...state,
                isRemovingWarningFlag: action.isRemoving,
            };
        case editScoringActions.RESET:
            return defaultState;
        default:
            return state;
    }
}
